// extracted by mini-css-extract-plugin
module.exports = {"gradient":"PriceDropBanner_gradient__pRkc2"};